import { render, staticRenderFns } from "./ProductsCounts.html?vue&type=template&id=fcab56e4&external"
import script from "./ProductsCounts.js?vue&type=script&lang=js&external"
export * from "./ProductsCounts.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports